export const isUrlInternalAbsolute = (url: string): boolean => {
  return /^(https?:\/\/)?www.whisky.fr\/|^(tel:)(https?:\/\/)?www.whisky.fr\/|^(mailto:)(https?:)?(\/\/)www.whisky.fr\//i.test(
    url
  );
};
export const isUrlAbsolute = (url: string): boolean => {
  return /^(https?:)?(\/\/)|^(tel:)|^(mailto:)/i.test(url);
};
